import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { EshopAPI } from '@twisto/api-cms'

import { EshopCard } from 'homepage/components/eshop-card'
import { useAdditionalData } from 'homepage/libs/context'

import * as styles from '../../eshops.styles'

export const SearchResults = ({ eshops }: { eshops: EshopAPI[] }) => {
  const { origin, staticTexts } = useAdditionalData()

  return (
    <main>
      <Typography css={styles.categoryTitle} variant="h2">
        {staticTexts?.searchResultsTitle}
      </Typography>

      <div css={styles.shopsInCategory}>
        {eshops.map((shop) => (
          <EshopCard
            key={shop.id}
            origin={origin || ''}
            shop={shop}
            variant="compact"
          />
        ))}
      </div>
    </main>
  )
}
